import React, { useCallback, useEffect, useState } from "react";
import { fetchPostLikes, togglePostLike } from "../../services/api";
import { getVisitorId } from "../../utils/visitor";
import styles from "./PostLikes.module.css";

export default function PostLikes({ slug }) {
    const [count, setCount] = useState(0);
    const [liked, setLiked] = useState(false);
    const [loading, setLoading] = useState(true);
    const [pending, setPending] = useState(false);

    const load = useCallback(async () => {
        try {
            const data = await fetchPostLikes(slug, getVisitorId());
            setCount(data.count || 0);
            setLiked(Boolean(data.liked));
        } catch {
            // curtidas não são críticas — falha silenciosa
        } finally {
            setLoading(false);
        }
    }, [slug]);

    useEffect(() => {
        setLoading(true);
        load();
    }, [load]);

    async function handleToggle() {
        if (pending) return;
        setPending(true);

        // Atualização otimista
        const prevLiked = liked;
        const prevCount = count;
        setLiked(!prevLiked);
        setCount(prevCount + (prevLiked ? -1 : 1));

        try {
            const data = await togglePostLike(slug, getVisitorId());
            setCount(data.count || 0);
            setLiked(Boolean(data.liked));
        } catch {
            // reverte em caso de erro
            setLiked(prevLiked);
            setCount(prevCount);
        } finally {
            setPending(false);
        }
    }

    return (
        <div className={styles.wrap}>
            <button
                type="button"
                className={`${styles.likeBtn} ${liked ? styles.liked : ""}`}
                onClick={handleToggle}
                disabled={loading || pending}
                aria-pressed={liked}
                aria-label={liked ? "Remover curtida" : "Curtir este artigo"}
            >
                <svg
                    className={styles.heart}
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill={liked ? "currentColor" : "none"}
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                >
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
                <span className={styles.label}>
                    {liked ? "Curtido" : "Curtir"}
                </span>
                <span className={styles.count}>{count}</span>
            </button>
            <p className={styles.hint}>
                {count === 0
                    ? "Seja o primeiro a curtir este artigo"
                    : count === 1
                    ? "1 pessoa curtiu este artigo"
                    : `${count} pessoas curtiram este artigo`}
            </p>
        </div>
    );
}
